<template>
	<div id="app">
		<Content v-bind:active="activeItem" v-bind:change="changeWatcher" v-touch:swipe="swipeHandler"></Content>
	</div>
</template>

<script>
  import Content from './components/Content'

  import $ from 'jquery';

  export default {
    name: 'app',
    components: {
      Content
    },
    data () {
      return {
        activeItem: 0,
        changeWatcher: 0
      }
    },
    created() {
      let self = this
      window.addEventListener('keyup', function (event) {
        if (event.keyCode === 39) {
          self.changeWatcher++
          self.activeItem = 1
        } else if (event.keyCode === 37) {
          self.changeWatcher++
          self.activeItem = -1
        }
      })
    },
    methods: {
      swipeHandler: function (e) {
        if (e === 'right') {
          this.changeWatcher++
          this.activeItem = -1
        } else if (e === 'left') {
          this.changeWatcher++
          this.activeItem = 1
        }
      }
    }
  }
</script>

<style>
	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed,
	figure, figcaption, footer, header, hgroup,
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font: inherit;
		vertical-align: baseline;
		unselectable: on;
	}

	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure,
	footer, header, hgroup, menu, nav, section {
		display: block;
	}

	body {
		line-height: 1;
		overflow-x: hidden;
	}

	ol, ul {
		list-style: none;
	}

	blockquote, q {
		quotes: none;
	}

	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	@font-face {
		font-family: opinionpro;
		src: url('./assets/fonts/opinionpro-light.otf') format('opentype');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: opinionproextended;
		src: url('./assets/fonts/opinionproextended-light.otf') format('opentype');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: opinionproextracondensed;
		src: url('./assets/fonts/opinionproextracondensed-light.otf') format('opentype');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: opinionprocondensed;
		src: url('./assets/fonts/opinionprocondensed-light.otf') format('opentype');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: stereogothic;
		src: url('./assets/fonts/Stereo_Gothic_W01_850_Italic.ttf') format('truetype');
		font-weight: normal;
		font-style: italic;
	}

</style>



// WEBPACK FOOTER //
// src/App.vue?46998e7a